<template>
    <Card>
        <div class="total-line">
            <template v-for="(item, index) in dataList" :key="index">
                <TotalBlock v-bind="item"></TotalBlock>
                <div class="split-line" v-if="index < dataList.length - 1"></div>
            </template>
        </div>
    </Card>
</template>
<script>
import TotalBlock from "./TotalBlock.vue";
export default {
    name: "TotalNumber",
    components: { TotalBlock },
    data() {
        return {
            dataList: [],
        };
    },
    methods: {
        setData(data) {
            this.$ajax.post("/AnalyzeData/GetEntityTotalNumber", data).then((result) => {
                let arr = result.Data;
                let list = [
                    {
                        title: "客流量 (人次)",
                        data: {
                            d: arr[0].DataIn,
                            d1: arr[1].DataIn,
                            d2: arr[2].DataIn,
                            d3: arr[3].DataIn,
                        },
                        dec: 0,
                    },
                    {
                        title: "集客力 (人/㎡)",
                        data: {
                            d: arr[0].FlowDensity,
                            d1: arr[1].FlowDensity,
                            d2: arr[2].FlowDensity,
                            d3: arr[3].FlowDensity,
                        },
                        dec: 2,
                    },
                    {
                        title: "销售额 (元)",
                        data: {
                            d: arr[0].Amount,
                            d1: arr[1].Amount,
                            d2: arr[2].Amount,
                            d3: arr[3].Amount,
                        },
                        dec: 2,
                    },
                    {
                        title: "提袋率 (%)",
                        data: {
                            d: arr[0].OrderRate,
                            d1: arr[1].OrderRate,
                            d2: arr[2].OrderRate,
                            d3: arr[3].OrderRate,
                        },
                        dec: 2,
                    },
                    {
                        title: "客单价 (元/人次)",
                        data: {
                            d: arr[0].Price,
                            d1: arr[1].Price,
                            d2: arr[2].Price,
                            d3: arr[3].Price,
                        },
                        dec: 2,
                    },
                    {
                        title: "坪效 (㎡)",
                        data: {
                            d: arr[0].Effect,
                            d1: arr[1].Effect,
                            d2: arr[2].Effect,
                            d3: arr[3].Effect,
                        },
                        dec: 2,
                    },
                ];
                this.dataList = list;
            });
        },
    },
};
</script>
